<template>
	<form
		name="requestForm"
		id="requestForm"
		action="/api/contact/request"
		method="post"
		enctype="multipart/form-data"
		autocomplete="off"
		onsubmit="return false;"
	>
		<div class="request">
			<h1 class="tit">견적의뢰</h1>
			<div class="request-cont">
				<p class="txt">
					견적, 제안, 프로젝트 구축 및 유지보수에 관한 문의를 해 주시기
					바랍니다.
				</p>
				<table>
					<caption>
						REQUEST 작성 테이블
					</caption>
					<colgroup>
						<col style="width: 120px" />
						<col style="width: auto" />
					</colgroup>
					<tr>
						<th>소속 및 성명</th>
						<td>
							<input
								type="text"
								id="txtName"
								name="txtName"
								v-model="form.txtName"
								maxlength="50"
								style="width: 304px"
							/>
						</td>
					</tr>
					<tr>
						<th>전화번호</th>
						<td>
							<input
								type="text"
								id="txtTel"
								name="txtTel"
								v-model="form.txtTel"
								maxlength="50"
								style="width: 304px"
							/>
						</td>
					</tr>
					<tr>
						<th>이메일</th>
						<td>
							<input
								type="text"
								id="txtEmail"
								name="txtEmail"
								v-model="form.txtEmail"
								maxlength="100"
								style="width: 304px"
							/>
						</td>
					</tr>
					<tr>
						<th>제목</th>
						<td>
							<input
								type="text"
								id="txtTitle"
								name="txtTitle"
								v-model="form.txtTitle"
								maxlength="200"
							/>
						</td>
					</tr>
					<tr>
						<th>문의내용</th>
						<td>
							<textarea
								id="txtContents"
								name="txtContents"
								v-model="form.txtContents"
							></textarea>
						</td>
					</tr>
					<tr>
						<th>파일첨부</th>
						<td id="addFile">
							<input
								type="file"
								id="attachFile"
								name="attachFile"
								v-on:change="fnFileChk(this)"
							/>
							<p>
								첨부파일 최대 허용 용량은 <strong>10MB</strong>입니다.
								<span class="ib"
									>(MS Word/PowerPoint/Excel, pdf, jpg, gif, png, zip
									첨부가능)</span
								>
							</p>
						</td>
					</tr>
					<tr>
						<th>개인정보수집동의</th>
						<td>
							<div class="privacy">
								- 주식회사 제오젠(이하 회사)은 고객의 개인정보를 소중하게
								생각하며, 「개인정보보호법」 등 관련법규를 준수하기 위해
								개인정보 처리방침을 제정하고 이를 준수하고 있습니다.<br />
								- 개인정보 처리방침은 법률의 제/개정, 정부의 정책 변경, 회사의
								내부 방침의 변경에 따라 바뀔 수 있습니다.<br />
								- 회사는 개인정보 처리방침을 개정하는 경우
								회사홈페이지(www.xeogen.com)를 통하여 공지(또는 개별공지)할
								것입니다.<br />
								- 회사의 개인정보 처리방침은 다음과 같은 내용을 담고
								있습니다.<br /><br />

								제1조 (개인정보의 수집 및 이용 목적)<br />
								제2조 (수집하는 개인정보 항목 및 수집방법)<br />
								제3조 (수집하는 개인정보의 보유 및 이용기간)<br />
								제4조 (수집하는 개인정보의 파기)<br />
								제5조 (정보주체의 권리•의무 및 그 행사방법에 관한 사항)<br />
								제6조 (개인정보 보호책임자)<br />
								제7조 (개인정보 처리방침 변경에 따른 고지)<br />
								제8조 (개인정보의 안전성 확보조치)<br />
								제9조 (권익침해 구제방법)<br />

								제1조 (개인정보의 수집 및 이용 목적)<br />
								1. 가. 회사는 다음과 같은 목적을 위하여 개인정보를
								수집합니다.<br />
								- 서비스 제공(프로젝트 문의)<br />
								- 서비스 이행(프로젝트 문의 답변 등)<br />
								2. 단, 이용자의 기본적 인권 침해의 우려가 있는 민감한 개인정보
								(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및
								범죄기록, 건강상태 및 성생활 등) 는 수집하지 않습니다.<br /><br />

								제2조 (수집하는 개인정보 항목 및 수집방법)<br />
								1. 각종 서비스 제공을 위해 아래와 같은 개인정보를 수집하고
								있습니다.<br />
								2. 가. Recruit<br />
								- 개인정보 항목 : 성명, 전화번호, E-mail, 입사지원 내용,
								입사지원서 첨부파일<br />
								- 보유근거 : 정보보호정책서 및 개인정보 보호지침<br />
								- 수집방법 : 인터넷 홈페이지(http://www.xeogen.com/)<br />
								3. 나. Project Request<br />
								- 개인정보 항목: 성명, 소속, 전화번호, E-mail, 문의 내용, 문의
								내용 첨부파일<br />
								- 보유근거 : 정보보호정책서 및 개인정보 보호지침<br />
								- 수집방법 : 인터넷 홈페이지(http://www.xeogen.com/)<br /><br />

								제3조 (수집하는 개인정보의 보유 및 이용기간)<br />
								1. 이용자의 개인정보는 다음과 같이 개인정보의 수집목적 또는
								제공받은 목적이 달성되면 파기됩니다.<br />
								- Project Request : 프로젝트 문의 완료 및 미진행 확정 시<br />
								위 보유기간에도 불구하고 계속 보유하여야 할 필요가 있을 경우에는
								이용자의 동의를 받겠습니다.<br /><br />

								제4조 (수집하는 개인정보의 파기) <br />
								1. 가. 파기 절차<br />
								이용자가 입력한 정보는 목적 달성 후 내부 방침 및 관련 법령에
								따라 일정기간 저장된 후 혹은 즉시 파기됩니다.<br />
								2. 나. 파기 기한<br />
								이용자의 개인정보는 개인정보의 보유기간이 경과된 경우 보유기간의
								종료일로부터 5일 이내에, 개인정보의 처리 목적 달성 등 그
								개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한
								것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.<br /><br />

								제5조 (정보주체의 권리•의무 및 그 행사방법에 관한 사항) <br />
								1. 이용자는 정보주체로서 다음과 같은 권리를 행사할 수 있습니다.
								<br />
								2. 가. 개인정보 열람 요구 : 회사에서 보유하고 있는 개인정보는
								「개인정보보호법」 제35조(개인정보의 열람)에 따라 열람을 요구할
								수 있습니다. 개인정보 열람 요구 시 법 제35조 5항에 의하여 열람을
								제한할 수 있습니다.<br />
								- 법률에 따라 열람이 금지되거나 제한되는 경우<br />
								- 다른 사람의 생명•신체를 해할 우려가 있거나 다른 사람의 재산과
								그 밖의 이익을 부당하게 침해할 우려가 있는 경우<br />
								3. 나. 개인정보 정정•삭제 요구 : 회사에서 보유하고 있는
								개인정보는 「개인정보보호법」 제36조(개인정보의 정정•삭제)에
								따라 정정•삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그
								개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할
								수 없습니다.<br />
								4. 다. 개인정보 처리정지 요구 : 회사에서 보유하고 있는
								개인정보는 「개인정보보호법」 제37조(개인정보의 처리정지 등)에
								따라 처리정지를 요구할 수 있습니다. 개인정보 처리정지 요구 시 법
								제37조 2항에 의하여 처리정지 요구를 거절할 수 있습니다.<br />
								- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여
								불가피한 경우<br />
								- 다른 사람의 생명•신체를 해할 우려가 있거나 다른 사람의 재산과
								그 밖의 이익을 부당하게 침해할 우려가 있는 경우<br />
								- 개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를
								제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가 그
								계약의 해지 의사를 명확하게 밝히지 아니한 경우<br />
								5. 개인정보 열람, 정정•삭제, 처리정지 요구는 회사의 개인정보보호
								담당자에게 전화, 이메일 등을 통해 연락하여 본인인증 절차를 거친
								후 가능합니다.<br /><br />

								제6조 (개인정보 보호책임자) <br />
								1. 고객의 개인정보를 보호하고 개인정보와 관련한 불만사항 및
								문의를 처리하기 위해 다음과 같이 관련부서 및 개인정보
								보호책임자를 지정하고 있습니다. <br />
								2. 가. 개인정보 보호책임자<br />
								성명: 박운재 팀장<br />
								소속: IT개발실전화: 02) 3218-3558<br />
								이메일: dallu@xeogen.com<br />
								3. 나. 개인정보 보호담당자<br />
								성명: 윤영진 <br />
								소속: 경영지원실<br />
								전화: 02) 3218-3503<br />
								이메일: dbsdud112@xeogen.com<br /><br />

								제7조 (개인정보 처리방침 변경에 따른 고지) <br />
								1. 이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에
								따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 가능한
								변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.<br />
								2. 공고일자 : 2011년 9월 30일<br />
								3. 시행일자 : 2011년 9월 30일<br /><br />

								제8조 (개인정보의 안전성 확보조치) <br />
								1. 「개인정보보호법」 제29조에 따라 다음과 같이 안전성 확보에
								필요한 기술적, 관리적, 물리적 조치를 하고 있습니다.<br />
								2. 가. 내부관리계획의 수립 및 시행 <br />
								회사의 내부관리계획 수립 및 시행은 행정안전부의 내부관리 지침을
								준수하여 시행합니다. <br />
								3. 나. 개인정보 처리담당자의 최소화 및 교육 <br />
								개인정보를 처리하는 담당자를 지정하고 최소화하여 개인정보를
								관리하는 대책을 시행하고 있습니다. <br />
								4. 다. 해킹 등에 대비한 기술적 대책 <br />
								해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기
								위하여 보안프로그램을 설치하고 주기적인 갱신•점검을 하며
								외부로부터 접근이 통제된 구역에 시스템을 설치하고
								기술적/물리적으로 감시 및 차단하고 있습니다. 또한 네트워크
								트래픽의 통제(Monitoring)는 물론 불법적으로 정보를 변경하는 등의
								시도를 탐지하고 있습니다. <br />
								5. 라. 비인가자에 대한 출입 통제 <br />
								개인정보를 보관하고 있는 개인정보시스템의 물리적 보관 장소를
								별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고
								있습니다.<br /><br />

								제9조 (권익침해 구제방법) <br />
								1. 정보주체는 개인정보 침해로 인한 구제를 받기 위하여
								개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보 침해 신고센터
								등에 분쟁해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타
								개인정보 침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기
								바랍니다. <br />
								2. 가. 개인분쟁조정위원회 (www.1336.or.kr/1336)<br />
								3. 나. 정보보호마크인증위원회
								(www.eprivacy.or.kr/02-580-0533~4)<br />
								4. 다. 대검찰청 인터넷범죄수사센터
								(http://icic.sppo.go.kr/02-3480-3600)<br />
								5. 라. 경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)
							</div>
							<div class="checkboxform">
								<input type="checkbox" id="chkAgree" name="chkAgree" />
								<label for="chkAgree"
									>개인정보 수집 및 이용에 동의합니다.</label
								>
							</div>
						</td>
					</tr>
				</table>
				<div class="btn-area">
					<button v-on:click.prevent="fnSave()">확인</button>
					<button v-on:click.prevent="fnClose()">취소</button>
				</div>
			</div>
		</div>
		<!-- //견적 요청 -->
	</form>
</template>

<script>
import "../../static/js/jquery.form.js";

var fileCheckUtil = {
	// pdf, zip
	getEtcFileType(filePath) {
		var index = -1;
		index = filePath.lastIndexOf(".");

		var type = "";

		if (index != -1) {
			type = filePath.substring(index + 1, filePath.len);
		} else {
			type = "";
		}

		if (type.toLowerCase() == "pdf" || type.toLowerCase() == "zip") {
			if (this.getFileName(filePath)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//jpg, gif, png, bmp
	getImageType(filePath) {
		var index = -1;
		index = filePath.lastIndexOf(".");

		var type = "";

		if (index != -1) {
			type = filePath.substring(index + 1, filePath.len);
		} else {
			type = "";
		}

		if (
			type.toLowerCase() == "jpg" ||
			type.toLowerCase() == "jpeg" ||
			type.toLowerCase() == "gif" ||
			type.toLowerCase() == "png" ||
			type.toLowerCase() == "bmp"
		) {
			if (this.getFileName(filePath)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//excel
	getExcelType(filePath) {
		var index = -1;
		index = filePath.lastIndexOf(".");

		var type = "";

		if (index != -1) {
			type = filePath.substring(index + 1, filePath.len);
		} else {
			type = "";
		}

		if (type.toLowerCase() == "xls" || type.toLowerCase() == "xlsx") {
			if (this.getFileName(filePath)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//Power point
	getPowerPointType(filePath) {
		var index = -1;
		index = filePath.lastIndexOf(".");

		var type = "";

		if (index != -1) {
			type = filePath.substring(index + 1, filePath.len);
		} else {
			type = "";
		}

		if (type.toLowerCase() == "ppt" || type.toLowerCase() == "pptx") {
			if (this.getFileName(filePath)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//Ms Word
	getWordType(filePath) {
		var index = -1;
		index = filePath.lastIndexOf(".");

		var type = "";

		if (index != -1) {
			type = filePath.substring(index + 1, filePath.len);
		} else {
			type = "";
		}

		if (type.toLowerCase() == "doc" || type.toLowerCase() == "docs") {
			if (this.getFileName(filePath)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	//jpg, gif, png
	getFileName(filePath) {
		var extension = -1;
		extension = filePath.lastIndexOf(".");

		var index = -1;
		index = filePath.lastIndexOf("\\") + 1;

		var fileName = "";

		if (index != -1) {
			fileName = filePath.substring(index, extension);
		} else {
			fileName = "";
		}

		if (fileName.match(/[^a-zA-Z0-9\_\-\)\(\.]/) != null) {
			return false;
		}
		return true;
	},
};
var dateComponent = {
	template:
		'<input type="file" id="attachFile" name="attachFile" change="fnFileChk()" />',
	data: function () {},
};
export default {
	metaInfo: {
		title: "Request",
		// meta: [
		// 	{
		// 		vmid: "description",
		// 		name: "description",
		// 		content: "2012년 이후 제오젠 포트폴리오",
		// 	},
		// ],
	},
	data() {
		return {
			form: {
				txtName: "",
				txtTel: "",
				txtEmail: "",
				txtTitle: "",
				txtContents: "",
				attachFile: Object,
			},
		};
	},
	mounted() {
		/*
        $('#requestForm').ajaxForm({
            success: function (res) {
                console.log('success >> ' + res);
                if(res.bindingStatus == true){
                   alert("귀하의 문의가 접수되었습니다.");
                   window.close();
                }
                else {
                	alert("문의에 실패하였습니다. \n관리자에게 연락 바랍니다.");
                }
            },error: function (req) {
                console.log('error >> ' + req);
                alert("문의에 실패하였습니다. \n관리자에게 연락 바랍니다.");
            } 
        });
        */
	},
	computed: {},
	methods: {
		fnSave: function () {
			if (this.fnChk()) {
				//$('#requestForm').submit();
				let file = document.getElementById("attachFile");
				let form = new FormData();
				form.append("txtName", this.form.txtName);
				form.append("txtTel", this.form.txtTel);
				form.append("txtEmail", this.form.txtEmail);
				form.append("txtTitle", this.form.txtTitle);
				form.append("txtContents", this.form.txtContents);
				form.append("attachFile", file.files[0]);
				this.$axios
					.post("/api/contact/request", form, {
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
					.then((res) => {
						if (res.data.bindingStatus) {
							alert("귀하의 문의가 접수되었습니다.");
							window.close();
						} else {
							alert("문의에 실패하였습니다. \n관리자에게 연락 바랍니다.");
						}
					})
					.catch((error) => {
						console.log("error >> " + error);
						alert("문의에 실패하였습니다. \n관리자에게 연락 바랍니다.");
					});
			}
		},
		fnClose: function () {
			//this.$router.push({path: '/contact'});
			window.close();
		},
		fnFileChk: function (obj) {
			var fileVal = $("#attachFile").val();
			var browser = this.ieVersion();
			if (fileVal != "") {
				if (browser == "N/A" || Number(browser) > 9) {
					if ($("#attachFile")[0].files[0].size > 10485760) {
						alert("파일사이즈 10MB를 넘을수 없습니다.");
						return false;
					}
				}
				if (
					!fileCheckUtil.getEtcFileType(fileVal) &&
					!fileCheckUtil.getImageType(fileVal) &&
					!fileCheckUtil.getExcelType(fileVal) &&
					!fileCheckUtil.getPowerPointType(fileVal) &&
					!fileCheckUtil.getWordType(fileVal)
				) {
					alert("올바른 파일이 아닙니다.");
					//var filenm = '<input type="file" id="attachFile" name="attachFile" change="fnFileChk()" />';
					//$("#attachFile").remove();
					//$("#addFile").prepend(filenm);
					document.getElementById("attachFile").value = "";
					return false;
				}
			}
		},
		fnChk: function () {
			if ($("#txtName").val() == "") {
				alert("소속 및 성명을 입력해 주세요.");
				$("#txtName").focus();
				return;
			}
			if ($("#txtTel").val() == "") {
				alert("전화번호를 입력해 주세요.");
				$("#txtTel").focus();
				return;
			}
			if ($("#txtEmail").val() == "") {
				alert("이메일을 입력해 주세요.");
				$("#txtEmail").focus();
				return;
			} else if (!this.fnIsEmail($("#txtEmail").val())) {
				alert("이메일을 정확히 입력해 주세요.");
				$("#txtEmail").focus();
				$("#txtEmail").val("");
				return;
			}
			if ($("#txtTitle").val() == "") {
				alert("제목을 입력해 주세요.");
				$("#txtTitle").focus();
				return;
			}
			if ($("#txtContents").val() == "") {
				alert("내용을 입력해 주세요.");
				$("#txtContents").focus();
				return;
			}
			if (!$("#chkAgree").is(":checked")) {
				alert("개인정보 수집 및 이용에 동의해 주세요.");
				$("#chkAgree").focus();
				return;
			}
			return true;
		},
		fnIsEmail: function (strValue) {
			var pat = /^\s*[\w\~\-\.]+\@[\w\~\-]+(\.[\w\~\-]+)+\s*$/g;
			return pat.test(strValue);
		},
		ieVersion: function () {
			var word;
			var version = "N/A";
			var agent = navigator.userAgent.toLowerCase();
			var name = navigator.appName;
			// IE old version ( IE 10 or Lower )
			if (name == "Microsoft Internet Explorer") word = "msie ";
			else {
				// IE 11
				if (agent.search("trident") > -1) word = "trident/.*rv:";
				// Microsoft Edge
				else if (agent.search("edge/") > -1) word = "edge/";
			}
			var reg = new RegExp(word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})");
			if (reg.exec(agent) != null) version = RegExp.$1 + RegExp.$2;
			return version;
		},
	},
	created() {
		//console.log('xgRequest');
	},
	components: {},
};
</script>


// WEBPACK FOOTER //
// src/components/XgRequest.vue